<template>
    <zoezi-autocomplete
        v-model="font"
        class="zoezi-edit-font"
        :items="$store.state.fonts || []"
        :label="label"
        color="zoezi-edit-color"
        item-color="zoezi-edit-color"
        @input="$emit('input', font)"
        :hint="hint"
        clearable
    />
</template>

<script>
import ZoeziAutocomplete from './ui/form/Autocomplete.vue';

export default {
    name: 'zoezi-font-setting',

    components: {
        ZoeziAutocomplete
    },

    props: ['value', 'label', 'hint'],

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.font = value;
            }
        }
    },

    data: () => ({
        font: null
    }),

    mounted() {
        if (!this.$store.state.fonts) {
            this.$api.get('/api/homepage/fonts/get').then(fonts => this.$store.commit('setFonts', fonts));
        }
    }
}
</script>
